require('./stylesheets/style.scss');

angular.module('pages.error404', [])
    .config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider
        .state('pages.error404', {
            url: '404',
            template: require('./templates/index.html'),
            controller: require('./controllers/error404'),
            data: {},
            params: {},
            pageTrack: '/error404'
        });
}

module.exports = 'pages.error404';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/404/index.js
 ** module id = 254
 ** module chunks = 1
 **/